export default "__VITE_ASSET__BNDfSuoY__"